export const mainPath = "https://testsolarstudiohr.beupsoft.pl/api";

